import { SubmissionError } from 'redux-form';
import messages from '../../locale/messages';
import history from '../../core/history';
import fetch from '../../core/fetch';
import { setRuntimeVariable } from '../../actions/runtime';
import { loadAccount } from '../../actions/account';
import { closeLoginModal } from '../../actions/modalActions';
import { referralURL } from '../../helpers/formatURL';
import { encode } from '../../helpers/queryEncryption'
import { setCookies } from '../../helpers/cookies';


async function submit(values, dispatch) {

  const query = `query (
    $email: String!,
    $password: String!,
  ) {
      userLogin (
        email: $email,
        password: $password,
      ) {
        status
        token
        expiresIn
      }
    }`;

  const params = {
    email: values?.email,
    password: encode(values?.password),
  };

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
      variables: params,
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.userLogin?.status == 'success') {
    setCookies({
      name: 'id_token',
      value: data?.userLogin?.token,
      options: { path: '/', maxAge: 1000 * data?.userLogin?.expiresIn }
    });
    dispatch(closeLoginModal());
    const loginScreen = true;
    let currentLocation, refer;
    
    // Check URL for redirect parameter first
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const redirectParam = urlParams.get('redirect');
      if (redirectParam) {
        refer = redirectParam;
        
        // Handle case where the URL has been modified during logout
        if (refer.includes('%2F')) {
          try {
            refer = decodeURIComponent(refer);
          } catch (e) {
            console.error('Error decoding redirect URL:', e);
          }
        }
      } else {
        // Fall back to form values or current location
        currentLocation = referralURL(history?.location);
        refer = values?.refer ? values?.refer : currentLocation;
      }
    } else {
      // For SSR, just use the form values
      currentLocation = referralURL(history?.location);
      refer = values?.refer ? values?.refer : currentLocation;
    }


    dispatch(loadAccount(loginScreen, refer));
    dispatch(setRuntimeVariable({
      name: 'isAuthenticated',
      value: true,
    }));
  } else if (data?.userLogin?.status == 'email') {
    throw new SubmissionError({ _error: messages.emailNotExists });
  } else if (data?.userLogin?.status == 'password') {
    throw new SubmissionError({ _error: messages.passwordWrong });
  } else if (data?.userLogin?.status == 'loggedIn') {
    dispatch(setRuntimeVariable({
      name: 'isAuthenticated',
      value: true,
    }));
    dispatch(loadAccount());
    throw new SubmissionError({ _error: messages.loggedIn });
  } else if (data?.userLogin?.status == 'adminLoggedIn') {
    throw new SubmissionError({ _error: messages.adminLoggedIn });
  } else if (data?.userLogin?.status == 'userbanned') {
    dispatch(closeLoginModal());
    history.push('/userbanned');
  } else if (data?.userLogin?.status == 'userDeleted') {
    throw new SubmissionError({ _error: messages.emailNotExists });
  } else {
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }
}

export default submit;
